var _classCallCheck = require("C:\\Users\\raju1\\Documents\\OpenSource\\JS-OS\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _createClass = require("C:\\Users\\raju1\\Documents\\OpenSource\\JS-OS\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/createClass");

var _inherits = require("C:\\Users\\raju1\\Documents\\OpenSource\\JS-OS\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/inherits");

var _createSuper = require("C:\\Users\\raju1\\Documents\\OpenSource\\JS-OS\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/createSuper");

/*!
 * @license Copyright (c) 2003-2020, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md.
 */
!function (e, t) {
  "object" == typeof exports && "object" == typeof module ? module.exports = t(require("react")) : "function" == typeof define && define.amd ? define(["react"], t) : "object" == typeof exports ? exports.CKEditor = t(require("react")) : e.CKEditor = t(e.React);
}(window, function (e) {
  return function (e) {
    var t = {};

    function o(n) {
      if (t[n]) return t[n].exports;
      var r = t[n] = {
        i: n,
        l: !1,
        exports: {}
      };
      return e[n].call(r.exports, r, r.exports, o), r.l = !0, r.exports;
    }

    return o.m = e, o.c = t, o.d = function (e, t, n) {
      o.o(e, t) || Object.defineProperty(e, t, {
        enumerable: !0,
        get: n
      });
    }, o.r = function (e) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    }, o.t = function (e, t) {
      if (1 & t && (e = o(e)), 8 & t) return e;
      if (4 & t && "object" == typeof e && e && e.__esModule) return e;
      var n = Object.create(null);
      if (o.r(n), Object.defineProperty(n, "default", {
        enumerable: !0,
        value: e
      }), 2 & t && "string" != typeof e) for (var r in e) {
        o.d(n, r, function (t) {
          return e[t];
        }.bind(null, r));
      }
      return n;
    }, o.n = function (e) {
      var t = e && e.__esModule ? function () {
        return e.default;
      } : function () {
        return e;
      };
      return o.d(t, "a", t), t;
    }, o.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, o.p = "", o(o.s = 2);
  }([function (e, t, o) {
    e.exports = o(3)();
  }, function (t, o) {
    t.exports = e;
  }, function (e, t, o) {
    "use strict";

    o.r(t), o.d(t, "default", function () {
      return a;
    });
    var n = o(1),
        r = o.n(n),
        i = o(0),
        s = o.n(i);

    var a = /*#__PURE__*/function (_r$a$Component) {
      _inherits(a, _r$a$Component);

      var _super = _createSuper(a);

      function a(e) {
        var _this;

        _classCallCheck(this, a);

        _this = _super.call(this, e), _this.editor = null, _this.domContainer = r.a.createRef();
        return _this;
      }

      _createClass(a, [{
        key: "shouldComponentUpdate",
        value: function shouldComponentUpdate(e) {
          return !!this.editor && (this._shouldUpdateContent(e) && this.editor.setData(e.data), "disabled" in e && (this.editor.isReadOnly = e.disabled), !1);
        }
      }, {
        key: "componentDidMount",
        value: function componentDidMount() {
          this._initializeEditor();
        }
      }, {
        key: "componentWillUnmount",
        value: function componentWillUnmount() {
          this._destroyEditor();
        }
      }, {
        key: "render",
        value: function render() {
          return r.a.createElement("div", {
            ref: this.domContainer,
            dangerouslySetInnerHTML: {
              __html: this.props.data || ""
            }
          });
        }
      }, {
        key: "_initializeEditor",
        value: function _initializeEditor() {
          var _this2 = this;

          this.props.editor.create(this.domContainer.current, this.props.config).then(function (e) {
            _this2.editor = e, "disabled" in _this2.props && (e.isReadOnly = _this2.props.disabled), _this2.props.onInit && _this2.props.onInit(e);
            var t = e.model.document,
                o = e.editing.view.document;
            t.on("change:data", function (t) {
              _this2.props.onChange && _this2.props.onChange(t, e);
            }), o.on("focus", function (t) {
              _this2.props.onFocus && _this2.props.onFocus(t, e);
            }), o.on("blur", function (t) {
              _this2.props.onBlur && _this2.props.onBlur(t, e);
            });
          }).catch(function (e) {
            (_this2.props.onError || console.error)(e);
          });
        }
      }, {
        key: "_destroyEditor",
        value: function _destroyEditor() {
          var _this3 = this;

          this.editor && this.editor.destroy().then(function () {
            _this3.editor = null;
          });
        }
      }, {
        key: "_shouldUpdateContent",
        value: function _shouldUpdateContent(e) {
          return this.props.data !== e.data && this.editor.getData() !== e.data;
        }
      }]);

      return a;
    }(r.a.Component);

    a.propTypes = {
      editor: s.a.func.isRequired,
      data: s.a.string,
      config: s.a.object,
      onChange: s.a.func,
      onInit: s.a.func,
      onFocus: s.a.func,
      onBlur: s.a.func,
      onError: s.a.func,
      disabled: s.a.bool
    }, a.defaultProps = {
      config: {}
    };
  }, function (e, t, o) {
    "use strict";

    var n = o(4);

    function r() {}

    function i() {}

    i.resetWarningCache = r, e.exports = function () {
      function e(e, t, o, r, i, s) {
        if (s !== n) {
          var a = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
          throw a.name = "Invariant Violation", a;
        }
      }

      function t() {
        return e;
      }

      e.isRequired = e;
      var o = {
        array: e,
        bool: e,
        func: e,
        number: e,
        object: e,
        string: e,
        symbol: e,
        any: e,
        arrayOf: t,
        element: e,
        elementType: e,
        instanceOf: t,
        node: e,
        objectOf: t,
        oneOf: t,
        oneOfType: t,
        shape: t,
        exact: t,
        checkPropTypes: i,
        resetWarningCache: r
      };
      return o.PropTypes = o, o;
    };
  }, function (e, t, o) {
    "use strict";

    e.exports = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  }]).default;
});